import { CircularProgress } from "@mui/material";
import { useGetYandexAutorizationUser } from "@src/entities/login";
import { useAuthStore } from "@src/entities/login/model/store/authStore";
import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export const YandexAutorizationPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const exchangeCode = searchParams.get("exchange_code");

  const { mutate: getYandexAutorizationUser, isPending } =
    useGetYandexAutorizationUser();
  const setUser = useAuthStore((s) => s.setUser);

  const calledRef = useRef(false);

  useEffect(() => {
    if (!exchangeCode) {
      navigate("/login", { replace: true });
      return;
    }

    if (calledRef.current) return;
    calledRef.current = true;

    getYandexAutorizationUser(
      {
        exchange_code: exchangeCode,
      },
      {
        onSuccess: (response) => {
          const user = {
            ...response?.data,
            tokens: { access_token: response.data.tokens.access },
          };
          setUser(user);

          navigate("/", { replace: true });
        },
        onError: () => {
          navigate("/login", { replace: true });
        },
      }
    );
  }, [exchangeCode]);

  return (
    <div style={{ padding: 32, textAlign: "center" }}>
      <h2>Выполняется вход…</h2>
      {isPending && <CircularProgress />}
    </div>
  );
};
